import { FilterValue } from '../../components';
import { useLastDate } from '../useLastDate';

interface GetGroupByIdArgs {
  filter: FilterValue[];
  groupId: string;
}

interface GetGroupItemValueArgs {
  filter: FilterValue[];
  groupId: string;
  itemId: string;
  propToReturn?: string;
}

interface GetGroupValueArgs {
  filter: FilterValue[];
  groupId: string;
  multiCheck?: boolean;
  propToMap?: string;
}

interface GetDateRangeArgs {
  filter: FilterValue[];
  groupId: string;
}

export const useFilter = () => {
  const { getDateRange } = useLastDate();

  const getGroupById = ({ filter, groupId }: GetGroupByIdArgs) => {
    return filter.find((group) => group.groupId === groupId);
  };

  const getGroupValue = ({
    filter,
    groupId,
    multiCheck = false,
    propToMap = 'value',
  }: GetGroupValueArgs) => {
    const groupValue =
      getGroupById({ filter, groupId })?.groupItems?.map((value) => value[propToMap]) ?? [];

    return !multiCheck ? groupValue[0] : groupValue;
  };

  const getGroupItemValue = ({
    filter,
    groupId,
    itemId,
    propToReturn = 'value',
  }: GetGroupItemValueArgs) => {
    return getGroupById({ filter, groupId })?.groupItems.find(({ id }) => id === itemId)?.[
      propToReturn
    ];
  };

  const getDateRangeValue = ({ filter, groupId }: GetDateRangeArgs) => {
    const dateRange = getGroupValue({ filter, groupId });
    return { dateRange, ...getDateRange(dateRange) };
  };

  return { getGroupById, getGroupItemValue, getGroupValue, getDateRangeValue };
};
